import React from 'react';
import PropTypes from 'prop-types';
import { Popover as BootstrapPopover, PopoverBody, PopoverHeader } from 'reactstrap';

class Popover extends React.Component {
  state = {
    showPopover: false,
  }

  toggle = () => this.setState(prevState => ({ showPopover: !prevState.showPopover }))

  onMouseEnter = () => {
    if (this.props.hover) this.setState({ showPopover: true });
  }

  onMouseLeave = () => {
    if (this.props.hover) this.setState({ showPopover: false });
  }

  render = () => (
    <React.Fragment>
      <span
        id={`popover-${this.props.id}`}
        className="material-icons md-18"
        onMouseLeave={this.onMouseLeave}
        onMouseEnter={this.onMouseEnter}
        onClick={this.toggle}
        role="button"
      >
        {this.props.icon || 'help'}
      </span>
      {this.props.description && (
        <span
          onClick={this.toggle}
          onMouseLeave={this.onMouseLeave}
          onMouseEnter={this.onMouseEnter}
        >
          {this.props.description}
        </span>
      )}
      <BootstrapPopover
        placement="top"
        isOpen={this.state.showPopover}
        toggle={this.toggle}
        target={`popover-${this.props.id}`}
        trigger="legacy"
      >
        <PopoverHeader>
          <div className="popover-close" onClick={this.toggle}>
            <i className="material-icons">&#xE5CD;</i>
          </div>
        </PopoverHeader>
        <PopoverBody>
          {this.props.children}
        </PopoverBody>
      </BootstrapPopover>
    </React.Fragment>
  );
}

Popover.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  description: PropTypes.string,
  hover: PropTypes.bool,
  icon: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Popover;
